import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const contentRoutes: RouteObject = {
  children: [
    {
      path: ROUTES.content.blog,
      children: [
        {
          index: true,
          lazy: async () => {
            const { ArticlesPage } =
              await import('../../../pages/articles/Articles.page');

            return { Component: ArticlesPage };
          },
        },
        {
          path: ROUTES.content.articleEdit,
          lazy: async () => {
            const { ArticlesFormPage } =
              await import('../../../pages/articles/ArticlesForm.page');

            return { Component: ArticlesFormPage };
          },
        },
      ],
    },
    {
      path: ROUTES.content.events,
      lazy: async () => {
        const { HappeningPage } =
          await import('../../../pages/happening/Happening.page');

        return { Component: HappeningPage };
      },
    },
    {
      path: ROUTES.content.pharmacistWord,
      lazy: async () => {
        const { PharmacistWordPage } =
          await import('../../../pages/pharmacist-word/PharmacistWord.page');

        return { Component: PharmacistWordPage };
      },
    },
    {
      path: ROUTES.content.communicationMedia,
      lazy: async () => {
        const { CommunicationMediaPage } =
          await import('../../../pages/communication-media/CommunicationMedia.page');

        return { Component: CommunicationMediaPage };
      },
    },
  ],
};
